export default "__VITE_PUBLIC_ASSET__0843eeca__"